import React from "react";
import { ConfirmationBar } from "./confirmation-bar";
import { ConfirmationBarAcceptButton } from "./confirmation-bar-accept-button";
import { ConfirmationBarCancelButton } from "./confirmation-bar-cancel-button";

export const AcceptCancelConfirmationBar = ({
	title,
	acceptDisabled,
	cancelDisabled,
	className,
	onAccept,
	onCancel,
}: {
	title?: string;
	acceptDisabled?: boolean;
	cancelDisabled?: boolean;
	className?: string;
	onAccept: () => void;
	onCancel: () => void;
}) => (
	<ConfirmationBar
		className={className}
		left={
			<ConfirmationBarCancelButton
				disabled={cancelDisabled}
				onClick={() => {
					onCancel();
				}}
			/>
		}
		right={
			<ConfirmationBarAcceptButton
				disabled={acceptDisabled}
				onClick={() => {
					onAccept();
				}}
			/>
		}
		title={title}
	/>
);
AcceptCancelConfirmationBar.displayName = "AcceptCancelConfirmationBar";
